/* 
--- DEVELOPER WARNING ---
This is a generated file.
Any changes you make to this file will not be saved nor git tracked. 
*/

import objectDetection_IconURL from './Typescript_logo.png';
import objectDetection_InsetIconURL from './typescript-logo.svg';
import React from 'react';
import { FormattedMessage } from 'react-intl';
export default {
	name: 
  (
    <FormattedMessage
        defaultMessage="Object Detection"
        description="name for the Object Detection extension"
        id="extension.objectDetection.name"
    />
  ),
	description: 
  (
    <FormattedMessage
        defaultMessage="Detects and identifies the object shown!"
        description="description for the Object Detection extension"
        id="extension.objectDetection.description"
    />
  ),
	iconURL: objectDetection_IconURL,
	insetIconURL: objectDetection_InsetIconURL,
	tags: ["PRG Internal"],
	featured: true,
	extensionId: 'objectDetection',
}